import { User, Member } from '@quick/client';

export const identifySegment = async (user: User, member?: Member): Promise<void> => {
  const traits = {
    name: member?.name,
    email: user.email,
    memberId: member?.memberId,
    memberEmail: member?.email,
    communityId: member?.communityId,
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  await analytics.identify(user.userId.toString(), traits);

  if (member) {
    await analytics.group(member.communityId.toString());
  }
};

export const resetSegment = () => {
  analytics.reset();
};
